const development = {
  apiGateway: {
    BASE_URL: 'http://localhost:3000',
  },
};

const uat = {
  apiGateway: {
    BASE_URL: 'https://marketplaceuat-api.acrocalypse.gg',
  },
};

const production = {
  apiGateway: {
    BASE_URL: 'https://marketplace-api.acrocalypse.gg',
  },
};

let baseConfig =
  process.env.REACT_APP_STAGE === 'production' ? production : process.env.REACT_APP_STAGE === 'uat' ? uat : development;

const AppConfig = {
  REACT_APP_STAGE: process.env.REACT_APP_STAGE,
  REACT_APP_VERSION: 1,
  LOCAL_STORAGE_WALLET_KEY: 'marketplaceWalletAddress',
  REACT_APP_ETHERS_DEFAULT_NETWORK: process.env.REACT_APP_ETHERS_DEFAULT_NETWORK || '1',
  INFURA_ID: process.env.REACT_APP_INFURA_ID || '',
  PAPER_TOKEN_CONTRACT_ADDRESS: process.env.REACT_APP_PAPER_TOKEN_CONTRACT_ADDRESS || '',
  MARKETPLACE_CONTRACT_ADDRESS: process.env.REACT_APP_MARKETPLACE_CONTRACT_ADDRESS || '',
  EXPLORER_URL:
    process.env.REACT_APP_ETHERS_NETWORK === 'testnet' ? 'https://goerli.etherscan.io' : 'https://www.etherscan.io',
  ...baseConfig,
};

export default AppConfig;

// rebuild
